/**
 * Every failure this package produces.
 *
 * Built with `Object.assign(new Error(msg), { code })`, the way
 * web/src/api.ts builds its status errors: a `catch` switches on `code`
 * without importing a class, which also means an error survives being
 * thrown across a bundle boundary where `instanceof` would not.
 */
export function vmError(code, message, cause) {
    const err = Object.assign(new Error(message), { code });
    if (cause !== undefined)
        err.cause = cause;
    return err;
}
export function isVmError(value) {
    return value instanceof Error && typeof value.code === 'string';
}
/** The message of anything a `catch` can receive, for putting inside another error. */
export function messageOf(value) {
    return value instanceof Error ? value.message : String(value);
}
//# sourceMappingURL=errors.js.map